import { InjectionToken } from '@angular/core';
import { Environment } from '@common/util-models';

export const ENVIRONMENT = new InjectionToken<Environment>('App Environment');
